import $ from 'jquery';
import Dropzone from 'dropzone';
import { handleSidebarBackgrounds, sidebarLoader } from '~src/sidebar/index';
import { showSidebarTab, hideSidebarTab } from '~src/sidebarLegacy';
import { modifyState } from '~src/state';
import { uploadBackgroundFile } from '~src/backgrounds/backgroundStorage';

Dropzone.autoDiscover = false;

const uploadBackgrounds = (file, width, height, tags) =>
  uploadBackgroundFile({ file, height, tags, width });

function createDropzoneBackgrounds() {
  const previewTemplate = `<div
  class="items-tag-image-container">
    <img
        src="../assets/svg/img-loader.gif"
        class="lazy items-tag-image"
    />
  </div>`;

  const dropzoneBackgrounds = new Dropzone('#sidebar-box-backgrounds', {
    maxFiles: 20,
    autoProcessQueue: false,
    url: '/',
    timeout: 0,
    previewTemplate: previewTemplate,
    acceptedFiles: 'image/jpeg,image/jpg,image/png,image/gif,image/svg+xml',
    previewsContainer: '#editor-sidebar-backgrounds', // Define the container to display the previews
    clickable: '#editor-sidebar-backgrounds-upload-btn', // Define the element that should be used as click trigger to select files.
  });

  dropzoneBackgrounds.on('thumbnail', (file) => {
    $('#tab-backgrounds-tag-upload #editor-btn-spinner').show();

    setTimeout(async () => {
      if (typeof file.accepted !== 'undefined' && file.accepted === false) {
        console.error('File not accepted', file.accepted);
        $('#tab-backgrounds-tag-upload #editor-btn-spinner').hide();
        return;
      }

      const selectedTags = $('#tagBackgroundSelectUpload').val();

      try {
        sidebarLoader('editor-sidebar-backgrounds');
        await uploadBackgrounds(file, file.width, file.height, selectedTags);
        await handleSidebarBackgrounds(true);

        showSidebarTab('manifesti');
        hideSidebarTab('backgrounds-tag-upload');
      } catch (error) {
        console.error(error);
      } finally {
        $('#tab-backgrounds-tag-upload #editor-btn-spinner').hide();
      }
    }, 100);
  });

  modifyState('dropzoneBackgrounds', dropzoneBackgrounds);
}

export { uploadBackgrounds, createDropzoneBackgrounds };
